import React, { useState, useEffect } from "react";
import * as Icons from "react-feather";
import { useList } from "store/list";
import { useCore } from "store/core";
import Loading from "components/Loading";
import ListSearch from "components/list/ListSearch";
import ListPagination from "components/list/ListPagination";
import Add from "./Add";
import Edit from "./Edit";
import Delete from "./Delete";
import { handleSuccessMessages } from "store/auth";
import { Link } from "react-router-dom";
import core from "store/core";
import { toJalali } from "lib/helpers";
import ListFilter from "components/list/ListFilter";
import ReportPreviewModal from "components/ReportPreviewModal";
import PlayPreviewModal from "components/PlayPreviewModal";

export default function FestivalsProducts(props) {
  const path = {
    baseRoute: "/panel/products/festivals",
    aliasName: "محصولات جشنواره ها",
    type: "FestivalsProducts",
  };
  const {
    dispatch,
    clear,
    getList,
    list,
    load,
    remove,
    listSearch,
    from,
    to,
    listFilter,
    total,
  } = useList();
  const core = useCore();

  const [showDelete, setShowDelete] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [showPlayPreview, setShowPlayPreview] = useState(false);

  const [item, setItem] = useState(false);

  useEffect(() => {
    dispatch(getList(path));
    core.dispatch(core.getSliders());
    return () => {
      dispatch(clear());
    };
  }, []);

  const getTitle = (type) => {
    const titles = {
      Movie: "فیلم",
      Serie: "سریال",
      Music: "موزیک",
      SerieEpisode: "قسمت",
      Screening: "اکران",
      Physical: "محصولات فروشگاه",
      Download: "محصولات دانلودی",
    };
    return titles[type];
  };

  return (
    <>
      {/* <Delete
          title="حذف محصول"
          show={showReport} // mzchange
          close={() => {
            //setShowDelete(false);
          }}
        /> */}
      <Delete
        title="حذف محصول"
        show={showDelete}
        close={() => {
          setShowDelete(false);
        }}
        submite={() => {
          dispatch(
            remove(path, list, item.id, () => {
              handleSuccessMessages("عملیات با  انجام شد");
              dispatch(getList(path));
              setShowDelete(false);
            })
          );
        }}
      />
      <PlayPreviewModal
        show={showPlayPreview}
        close={() => {
          setShowPlayPreview(false);
        }}
        title={"پیش نمایش"}
        id={item.id}
      />

      <ReportPreviewModal
        show={showReport}
        close={() => {
          setShowReport(false);
        }}
        title={"تعداد بازدید"}
        id={item.id}
      />

      <div className="content" style={{ marginBottom: 80 }}>
        <h2 className="intro-y text-lg font-medium mt-10">{getTitle()}</h2>
        <div className="grid grid-cols-12 gap-6 mt-5">
          <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
            {/* {festival_id ? (
              <Link to={`/products/festival/${festival_id}/wizard`}>
                <a className="btn btn-primary shadow-md mr-2">ایجاد محصول</a>
              </Link>
            ) : (
              <>
                {props.plus ? (
                  <Link to="/products/wizard?plus_movie=1">
                    <a className="btn btn-primary shadow-md mr-2">
                      ایجاد محصول
                    </a>
                  </Link>
                ) : (
                  <Link to="/products/wizard">
                    <a className="btn btn-primary shadow-md mr-2">
                      ایجاد محصول
                    </a>
                  </Link>
                )}
              </>
            )} */}
            {load && (
              <div className="hidden md:block mx-auto text-gray-600">
                در حال بارگذاری
              </div>
            )}
            {!load && (
              <div className="hidden md:block mx-auto text-gray-600">
                {total ? `نمایش ${from} تا ${to} از ${total}` : null}
              </div>
            )}

            <ListSearch
              search={(key) => {
                dispatch(listSearch(path, key));
              }}
            />
          </div>

          <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
            <table className="table table-report -mt-2">
              <thead>
                <tr>
                  <th className="whitespace-nowrap text-center">شناسه</th>
                  <th className="whitespace-nowrap text-center">عنوان</th>
                  <th className="whitespace-nowrap text-center">جشنواره</th>
                  <th className="whitespace-nowrap text-center">نوع</th>
                  <th className="whitespace-nowrap text-center">دسته بندی</th>
                  <th className="whitespace-nowrap text-center">تاریخ ثبت</th>
                  <th className="whitespace-nowrap text-center">
                    آخرین بروزرسانی
                  </th>
                  <th className="whitespace-nowrap text-center">عملیات</th>
                </tr>
              </thead>
              {load && <Loading />}
              {list && !list.length > 0 && (
                <h3 className="w-3/6 flex justify-center">چیزی یافت نشد</h3>
              )}
              <tbody>
                {!load &&
                  list &&
                  list.length > 0 &&
                  list.map((item) => (
                    <tr className="intro-x">
                      <td className="w-16 text-center">{item.id}</td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.detail && item.detail.title}
                        </p>
                      </td>

                      <td>
                        {" "}
                        <p className="font-medium whitespace-nowrap text-center">
                          {item?.festival?.title}
                        </p>
                      </td>

                      <td>
                        {" "}
                        <p className="font-medium whitespace-nowrap text-center">
                          {getTitle(item?.type)}
                        </p>
                      </td>
                      <td className="text-center">
                        {item.product_categories &&
                          item.product_categories.map((i) => i.name + ", ")}
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item &&
                            toJalali(item.created_at, "jYYYY-jMM-jDD HH:mm")}
                        </p>
                      </td>
                      <td>
                        <p className="font-medium whitespace-nowrap text-center">
                          {item.detail &&
                            toJalali(
                              item.detail.updated_at,
                              "jYYYY-jMM-jDD HH:mm"
                            )}
                          <br />
                          {item.updater && " توسط:" + item.updater.full_name}
                        </p>
                      </td>
                      <td className="table-report__action w-72">
                        <div className="flex justify-center items-center">
                          {!(item.type == "CafeScreening") && (
                            <a
                              className="flex items-center text-theme-1 ml-3 cursor-pointer"
                              onClick={() => {
                                setItem(item);
                                setShowReport(true);
                              }}
                            >
                              <Icons.Eye className="w-4 h-4 ml-1 " />
                              آمار
                            </a>
                          )}

                          {(item.type == "Screening" ||
                            item.type == "CafeScreening") && (
                            <Link
                              to={`/plans/${item.id}/${
                                item.detail && item.detail.title
                              }`}
                            >
                              <a className="flex items-center ml-3 cursor-pointer">
                                <Icons.CreditCard className="w-4 h-4 ml-1" />
                                پلن ها
                              </a>
                            </Link>
                          )}
                          <Link
                            to={
                              item?.festival_id
                                ? `/products/festival/${item?.festival_id}/wizard/${item.id}`
                                : `/products/wizard/${item.id}`
                            }
                          >
                            <a className="flex items-center ml-3 cursor-pointer">
                              <Icons.CheckSquare className="w-4 h-4 ml-1" />
                              ویرایش
                            </a>
                          </Link>
                          <a
                            className="flex items-center text-theme-6 ml-3 cursor-pointer"
                            onClick={() => {
                              setItem(item);
                              setShowDelete(true);
                            }}
                          >
                            <Icons.Trash2 className="w-4 h-4 ml-1 " />
                            حذف{" "}
                          </a>

                          {item.type != "Physical" &&
                            item.type != "Serie" &&
                            item.type != "CafeScreening" && (
                              <a
                                className="flex items-center ml-3 cursor-pointer"
                                onClick={() => {
                                  setItem(item);
                                  setShowPlayPreview(true);
                                }}
                              >
                                <Icons.PlayCircle className="w-4 h-4 ml-1" />
                                پخش
                              </a>
                            )}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <ListPagination
            getList={(page, perPage) => {
              dispatch(getList(path, page, perPage));
            }}
          />
        </div>
      </div>
    </>
  );
}
